"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function NewToast(_ref) {
  var children = _ref.children,
      programToast = _ref.programToast,
      programType = _ref.programType,
      date = _ref.date,
      LinkComponent = _ref.LinkComponent,
      linkTo = _ref.linkTo,
      w4wNumber = _ref.w4wNumber;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      closeToast = _useState2[0],
      setCloseToast = _useState2[1];

  if (programToast) {
    return /*#__PURE__*/_react["default"].createElement(ProgramToast2021, {
      programType: programType,
      date: date,
      LinkComponent: LinkComponent,
      linkTo: linkTo,
      w4wNumber: w4wNumber
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, closeToast ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "home-toast"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "toast-content"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "close-toast",
    onClick: function onClick() {
      return setCloseToast(true);
    }
  }, /*#__PURE__*/_react["default"].createElement("span", null, "\u2715")), children)));
}

function ProgramToast2021(_ref2) {
  var programType = _ref2.programType,
      date = _ref2.date,
      LinkComponent = _ref2.LinkComponent,
      linkTo = _ref2.linkTo,
      w4wNumber = _ref2.w4wNumber;

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      close = _useState4[0],
      setClose = _useState4[1];

  var bannerText;

  switch (programType) {
    case "EDU":
      bannerText = /*#__PURE__*/_react["default"].createElement("p", null, "We're hosting a healthcare symposium for students on ", date, ". ", /*#__PURE__*/_react["default"].createElement(LinkComponent, {
        to: linkTo
      }, "Sign up here!"));
      break;

    case "W4W":
      if (!w4wNumber) throw new Error("programType W4W requires prop w4wNumber");

      if (typeof w4wNumber !== "number") {
        if (w4wNumber !== "a") throw new Error("w4wNumber must be 'a' if not using a number");
      }

      bannerText = /*#__PURE__*/_react["default"].createElement("p", null, "We're providing FREE wisdom teeth removal surgery to ", w4wNumber, " local student", w4wNumber < 2 || w4wNumber === "a" ? "" : "s", ". ", /*#__PURE__*/_react["default"].createElement(LinkComponent, {
        to: linkTo
      }, "Apply by ", date, "!"));
      break;

    case "BLOOD":
      bannerText = /*#__PURE__*/_react["default"].createElement("p", null, "We're hosting a blood drive on ", date, ". ", /*#__PURE__*/_react["default"].createElement(LinkComponent, {
        to: linkTo
      }, "Sign up now"), " to donate blood and save lives.");
      break;

    case "SFT":
      bannerText = /*#__PURE__*/_react["default"].createElement("p", null, "One local teacher will receive a FREE smile makeover. ", /*#__PURE__*/_react["default"].createElement(LinkComponent, {
        to: linkTo
      }, "Vote now!"));
      break;

    case "NALO":
      bannerText = /*#__PURE__*/_react["default"].createElement("p", null, "Empower Beautify Fresno: Join us May 15 to clean up Logan Park. ", /*#__PURE__*/_react["default"].createElement(LinkComponent, {
        to: linkTo
      }, "Sign up today."));
      break;
  }

  if (close) return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "full-width-toast"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "full-width-toast__close-toast",
    onClick: function onClick() {
      return setClose(true);
    }
  }, "\u2716"), bannerText);
}

NewToast.propTypes = {
  children: _propTypes["default"].node.isRequired
};
var _default = NewToast;
exports["default"] = _default;

//# sourceMappingURL=NewToast.js.map